import { z } from "zod";
import { auditActorFields } from "../common/audit.js";
export const storeMapInfo = z.object({
    id: z.string().uuid(),
    name: z.string(),
    version: z.string(),
    isActive: z.boolean(),
    mapUrl: z.string().url().nullable(),
    annotationsGeojson: z.record(z.unknown()),
    coordinateConfig: z.record(z.unknown()),
    metadata: z.record(z.unknown()),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    ...auditActorFields,
});
export const storeMapsListResponse = z.object({ items: z.array(storeMapInfo) });
export const updateMapAnnotationsRequest = z.object({
    annotationsGeojson: z.record(z.unknown()),
});
// Upload response (multipart body not modeled in OpenAPI)
export const uploadStoreMapResponse = storeMapInfo;
export const deleteStoreMapResponse = z.object({ ok: z.literal(true) });
// Auto-generate fixtures from aruco markers (PGM-sourced maps only).
export const fixturePairInput = z.object({
    startTag: z.string().min(1),
    endTag: z.string().min(1),
    /**
     * Fixture name. Optional — the dialog auto-fills it from the tags but the
     * operator can edit it. When omitted/blank the backend falls back to
     * "Fixture <code>".
     */
    name: z.string().trim().max(200).optional(),
    // Number of fixtures evenly split along start→end. Still honoured everywhere,
    // but no longer a UI choice — the dialog always sends 1 (one fixture per
    // marker pair). Defaulted so callers can omit it.
    partition: z.number().int().min(1).max(100).default(1),
    // Shelves to generate per fixture, at levels 1..shelfCount, top to bottom. 0 = none. The
    // shelves are created and associated with the generated fixture.
    shelfCount: z.number().int().min(0).max(50).default(0),
});
export const generateFixturesRequest = z.object({
    pairs: z.array(fixturePairInput).min(1).max(50),
});
export const generateFixturesResponse = z.object({
    created: z.number().int(),
    skipped: z.number().int(),
    /** Shelves generated across all fixtures in this request. */
    shelvesCreated: z.number().int(),
    fixtures: z.array(z.object({ id: z.string().uuid(), code: z.string() })),
});
//# sourceMappingURL=store-maps.schemas.js.map